var FcOutlinedMultiSelectModule = /** @class */ (function () {
    function FcOutlinedMultiSelectModule() {
    }
    return FcOutlinedMultiSelectModule;
}());
export { FcOutlinedMultiSelectModule };
